import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN", numberLocale: "en-US" },
  { code: "fr", label: "Français", short: "FR", numberLocale: "fr-FR" },
  { code: "de", label: "Deutsch",  short: "DE", numberLocale: "de-DE" },
  { code: "es", label: "Español",  short: "ES", numberLocale: "es-ES" },
  { code: "it", label: "Italiano", short: "IT", numberLocale: "it-IT" },
];

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
  es: { translation: es },
  it: { translation: it },
};

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "s1000d-lang",
      },
    });
}

export function localeOf(lng) {
  const found = SUPPORTED_LANGUAGES.find((l) => l.code === lng);
  return found?.numberLocale || "en-US";
}

export default i18n;
